export const KarmaPoolNoteTagManager = (local, setLocal, getURLBasePath) => {

    function getMoodTags() {
        return local.moodTags;
    }

    function getGenreTags() {
        return local.genreTags;
    }

    function getMoodTagById(id)
    {
        if (local.moodTags === undefined || local.moodTags === null) {
            return null;
        }

        return local.moodTags.find(tag => tag.id === id);
    }

    function getGenreTagById(id)
    {
        if (local.genreTags === undefined || local.genreTags === null) {
            return null;
        }

        return local.genreTags.find(tag => tag.id === id);
    }

    function fetchMoodTags() {
        fetch(getURLBasePath() + 'moodTag', {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setLocal(prevValue => {
                    return { ...prevValue, moodTags: data };
                });
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function fetchGenreTags() {
        fetch(getURLBasePath() + 'genreTag', {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json',
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setLocal(prevValue => {
                    return { ...prevValue, genreTags: data };
                });
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    return {
        getMoodTags, getGenreTags, fetchMoodTags, fetchGenreTags, getMoodTagById, getGenreTagById
    };
}